import * as React from 'react';
import {Field, Form, Formik} from 'formik';
import {
    Autocomplete,
    Backdrop,
    Button,
    Card,
    CircularProgress,
    Grid,
    IconButton,
    InputAdornment,
    TextField as MaterialTextField,
    Typography
} from '@mui/material';
import {TextField} from 'formik-material-ui';
import {withStyles} from '@mui/styles';
import {actions as opportunityActions, selectors as opportunitySelectors} from '../../../../Ducks/opportunity';
import {selectors as dashboardSelectors} from '../../../../Ducks/dashboard';
import {actions as contactsActions, selectors as contactsSelectors} from '../../../../Ducks/contacts';
import {selectors as accountSelectors} from '../../../../Ducks/account';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import LostModalV2 from '../Modals/LostModalV2';
import NewSaleLostModal from '../Modals/NewSaleLostModal'
import WonModal from '../Modals/WonModal';
import CvrModal from '../Modals/CvrModal';
import TransferModal from '../Modals/TransferModal';
import {useParams} from 'react-router-dom';
import {toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import SelectBox from '../../../Common/SelectBox';
import Swal from 'sweetalert2';
import SwitchToInvoicesConfirmationModal from '../Modals/SwitchToInvoicesConfirmationModal';
import {LoadingButton} from '@mui/lab';
import {fetchGet} from "../../../../API/util";
import Tooltip from "@mui/material/Tooltip";
import {Info} from "@mui/icons-material";
import {getProductCountry} from "../../../../API/products";
import {DENMARK, NEW_SALE, RESALE, WIN_BACK_TYPE} from "../../../Utils/constants";
import {selectors as adminSelectors} from "../../../../Ducks/admin";
import AlertElement from "../../../Common/Alert";
import {
    checkIfPersonFoodConsiderationHasChanged,
    parseCVR,
    validateEan,
    validateEmail
} from "../../../Utils/validations";
import MultipleEanModal from "../Modals/MultipleEanModal";
import {getPaymentTerms} from "../../../../API/invoice";

toast.configure();

const useStyles = _theme => ({
    noPadding: {
        padding: 0
    },
    container: {
        padding: 0,
        margin: 0
    }
});

class Deal extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            openLost: false,
            openWon: false,
            openCvr: false,
            openTransfer: false,
            openSwitchToInvoicesConfirmation: false,
            openMultipleEan: false,
            selectedValue: null,
            formValues: {},
            cvrData: null,
            salesRep: "",
            users: [],
            pipelineID: "",
            pipelineStages: [],
            paymentTermsOptions: [],
            assignedOpportunity: false,
            errorMsg: [],
            productCountry: null,
            companyName: "",
            foodConsideration: "",
            foodAllergies: [],
            opportunityPatchData: {},
            bookkeepers: [],
            prevCompanyCvr: "",
            receiverType: "",
            jobEmail: "",
            isSaveButtonClicked: false,
            delayInvoiceOptions: [
                {
                    label: '0 Days',
                    key: '0 Days',
                    id: '0 Days'
                },
                {
                    label: '14 Days',
                    key: '14 Days',
                    id: '14 Days'
                },
                {
                    label: '30 Days',
                    key: '30 Days',
                    id: '30 Days'
                },
                {
                    label: '60 Days',
                    key: '60 Days',
                    id: '60 Days'
                },

            ],
            receiverTypeOptions: [
                {
                    label: "Send to Receiver email",
                    key: "receiver"
                },
                {
                    label: "Send to Bookkeeper",
                    key: "bookkeeper"
                },
                {
                    label: "Send to both",
                    key: "both"
                }
            ]
        }
        this.formRef = React.createRef();
        this._isMounted = false;
    }

    componentDidMount() {
        const {
            opportunity,
            getFoodConsiderations,
            getSalesReps,
            foodConsiderations,
        } = this.props;
        this._isMounted = true;
        getSalesReps();
        getFoodConsiderations();
        this.loadPaymentTerms();

        if (opportunity) {
            this.populateForm(opportunity, foodConsiderations);

            if (opportunity.main.product) {
                getProductCountry(opportunity.main.product).then((res) => {
                    if (res.country) {
                        this.setState({'productCountry': res.country});
                    }
                });
            }
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate(prevProps) {
        const {
            salesReps,
            pipelineId,
            opportunity,
            closedWon,
            foodConsiderations,
        } = this.props;

        if (prevProps.salesReps !== salesReps) {
            let users = salesReps.main.filter(item => item.user_deactivated === null && !item.user_lastname.includes("WRONG")).map((item, index) => {
                item.label = item.user_firstname + " " + item.user_lastname;
                item.key = {index}
                return item;
            });

            this.setState({users});
        }

        if (prevProps.pipelineId !== pipelineId && (this.state.salesRep !== "")) {
            if (pipelineId.length) {
                let pipeline_id = pipelineId[0].pipeline_id;
                this.setState({pipelineID: pipeline_id}, () => {
                    this.handleModal('openTransfer');
                })
            } else {
                // show toast
                toast.error('Cannot show stages as it has no pipeline id', {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    hideProgressBar: true,
                    autoClose: 2000
                });
            }
        }

        if (prevProps.opportunity !== opportunity) {
            opportunity && this.populateForm(opportunity, foodConsiderations);
            this.setState({prevCompanyCvr: ''});
        }

        if (prevProps.closedWon !== closedWon) {
            this.setState({openSwitchToInvoicesConfirmation: true});
        }
    }

    populateForm = (opportunity, foodConsiderations) => {
        const {
            opportunity_food_considerations_1,
            opportunity_food_considerations_2,
            job_id,
            opportunity_cvr_company
        } = opportunity.main;
        const personFoodConsideration = opportunity_food_considerations_1 === "" ? foodConsiderations?.type1_food?.find(item => item.id === 17).id : opportunity_food_considerations_1;
        const personFoodAllergies = opportunity_food_considerations_2?.length === 0 ? [foodConsiderations?.type2_food?.find(item => item.id === 18)?.id] : opportunity_food_considerations_2;
        const companyName = opportunity_cvr_company ?? opportunity.related_objects.persons[opportunity.related_objects.jobs[job_id].person_id].company_name;
        const opportunityPaymentTerms = opportunity.main.opportunity_payment_terms ?? opportunity.main.opportunity_payment_terms;
        const jobEmail = opportunity.related_objects.jobs[opportunity.main.job_id].job_email;

        this.formRef.current.setFieldValue('opportunity_cvr', opportunity.main.opportunity_cvr);
        this.formRef.current.setFieldValue('company_name', companyName);
        this.formRef.current.setFieldValue('opportunity_address_1', opportunity.main.opportunity_address_1);
        this.formRef.current.setFieldValue('opportunity_address_2', opportunity.main.opportunity_address_2);
        this.formRef.current.setFieldValue('opportunity_address_postal_code', opportunity.main.opportunity_address_postal_code);
        this.formRef.current.setFieldValue('opportunity_address_city', opportunity.main.opportunity_address_city);
        this.formRef.current.setFieldValue('opportunity_address_country', opportunity.main.opportunity_address_country);
        this.formRef.current.setFieldValue('opportunity_bookkeeper_email', opportunity.main.opportunity_bookkeeper_email);
        this.formRef.current.setFieldValue('opportunity_ean', opportunity.main.opportunity_ean);
        this.formRef.current.setFieldValue('opportunity_po_number', opportunity.main.opportunity_po_number);
        this.formRef.current.setFieldValue('opportunity_delayed_invoice', opportunity.main.opportunity_delayed_invoice);
        this.formRef.current.setFieldValue('opportunity_price', opportunity.main.opportunity_price);
        this.formRef.current.setFieldValue('opportunity_split_payment', opportunity.main.opportunity_split_payment);
        this.formRef.current.setFieldValue('opportunity_food_considerations', opportunity.main.opportunity_food_considerations);
        this.formRef.current.setFieldValue('person_food_considerations_1', personFoodConsideration);
        this.formRef.current.setFieldValue('person_food_considerations_2', personFoodAllergies);
        this.formRef.current.setFieldValue('person_food_considerations_other', opportunity.main.opportunity_food_considerations_other);
        this.formRef.current.setFieldValue('opportunity_special_conditions', opportunity.main.opportunity_special_conditions);
        this.formRef.current.setFieldValue('opportunity_payment_terms', opportunityPaymentTerms);

        let type = "";

        if (opportunity.main.opportunity_bookkeeper_email || opportunity.main.opportunity_ean) {
            type = "bookkeeper";
        }

        if (opportunity.main.opportunity_receiver_email) {
            if (type === "bookkeeper") {
                type = "both";
            } else {
                type = "receiver";
            }

            this.formRef.current.setFieldValue('opportunity_receiver_email', opportunity.main.opportunity_receiver_email);
        }

        this.setState({
            'companyName': companyName,
            'foodConsideration': personFoodConsideration,
            'foodAllergies': personFoodAllergies,
            'receiverType': type,
            'jobEmail': jobEmail});
    }

    handleModal = (modal) => {
        this.setState({[modal]: true});
    };

    handleClose = (modal = null) => {
        this.setState({
            openLost: false,
            openWon: false,
            openCvr: false,
            openTransfer: false,
            openSwitchToInvoicesConfirmation: false,
        });


        if (modal === "cvr") {
            //fetch bookkeeper by cvr
            this.fetchBookkeeperByCvr(this.formRef.current.values.opportunity_cvr);
        }
    };

    handleBlur = (e) => {
        const {opportunity} = this.props;
        const {name, value} = e.target;
        const trimmedValue = value?.trim();
        let formData = {...this.state.opportunityPatchData};

        if (opportunity.main[name] !== trimmedValue) {
            formData[name] = trimmedValue;
            this.setState({"opportunityPatchData": formData});
        } else {
            Object.keys(this.state.opportunityPatchData).forEach((key) => {
                if (key === name) {
                    delete formData[name];

                    this.setState({"opportunityPatchData": formData});
                }
            })
        }

        if (this.state.receiverType === "bookkeeper") {
            this.formRef.current.setFieldValue('opportunity_receiver_email', '');
        } else if (this.state.receiverType === "receiver") {
           this.formRef.current.setFieldValue('opportunity_bookkeeper_email', '');
           this.formRef.current.setFieldValue('opportunity_ean', '');
        }

        this.checkIfFieldValueHasChanged();
    }

    handleAllergiesChange = (e) => {
        let allergies = e.target.value;
        let filteredAllergies = allergies;

        if (allergies.includes(18)) {
            filteredAllergies = allergies.filter(item => item !== 18);
        } else if (!e.target.value.length) {
            filteredAllergies = [18];
        }

        this.formRef.current.setFieldValue('person_food_considerations_2', filteredAllergies);

        let formData = {...this.state.opportunityPatchData};
        formData.person_food_considerations_2 = filteredAllergies;

        this.setState({"opportunityPatchData": formData});
        this.checkIfFieldValueHasChanged();
    }

    handleCVR = (e) => {
        const {opportunity} = this.props;
        let formData = {...this.state.opportunityPatchData};

        if (opportunity.main[e.target.name] !== e.target.value) {
            formData.opportunity_cvr = e.target.value;

            this.setState({"opportunityPatchData": formData});

            if (e.target.value !== "" && !e.target.value.includes("-") && this.state.prevCompanyCvr !== e.target.value) {
                fetchGet(`/cvr-search/${e.target.value}`)
                    .then(function (response) {
                        const parsedCvr = parseCVR(response);

                        if (parsedCvr) {
                            this.setState({
                                cvrData: parsedCvr
                            }, () => {
                                this.handleModal('openCvr')
                            })
                        } else {
                            this.fetchBookkeeperByCvr(e.target.value);
                        }
                    }.bind(this));

                this.setState({prevCompanyCvr: e.target.value});
            }
        } else {
            Object.keys(this.state.opportunityPatchData).forEach((key) => {
                if (key === "opportunity_cvr") {
                    delete formData["opportunity_cvr"];

                    this.setState({"opportunityPatchData": formData});
                }
            })
        }

        this.checkIfFieldValueHasChanged();
    }

    saveInformation = () => {
        const {postOpportunityData, opportunity, foodConsiderations, setIsOpportunityDirty} = this.props;
        let formData = {...this.formRef.current.values};
        formData.opportunity_cvr_company = this.formRef.current.values.company_name;

        delete formData.company_name;

        if (formData.person_food_considerations_1 === "" || formData.person_food_considerations_2.length === 0) {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Food consideration can not be empty",
            });
        } else {
            const personFoodConsiderationHasChanged =
                checkIfPersonFoodConsiderationHasChanged(opportunity.main, this.formRef, foodConsiderations, 'opportunity', this.props);

            if (!personFoodConsiderationHasChanged) {
                postOpportunityData({formData, id: this.props.params.id});
            }

            setIsOpportunityDirty(false);
        }
    }

    handleTransferOpportunity = (_event, value) => {
        const {getPipelineId} = this.props;

        if (value !== null) {
            getPipelineId(value.user_id);
            this.setState({salesRep: value.user_id});
        } else {
            this.setState({salesRep: ""});
        }
    }

    setBookKeeperEmailOrEan = (formData, response) => {
        if (response[0].ean) {
            this.formRef.current.setFieldValue('opportunity_ean', response[0].ean);
            this.formRef.current.setFieldValue('opportunity_bookkeeper_email', '');

            formData.opportunity_ean = response[0].ean;
            formData.opportunity_bookkeeper_email = '';
        } else if (response[0].bookkeeper_email) {
            this.formRef.current.setFieldValue('opportunity_ean', '');
            this.formRef.current.setFieldValue('opportunity_bookkeeper_email', response[0].bookkeeper_email);

            formData.opportunity_ean = '';
            formData.opportunity_bookkeeper_email = response[0].bookkeeper_email;
        } else if (response[0].ean === '') {
            this.formRef.current.setFieldValue('opportunity_ean', '');
            this.formRef.current.setFieldValue('opportunity_bookkeeper_email', '');

            formData.opportunity_ean = '';
            formData.opportunity_bookkeeper_email = '';
        }

        if (response[0].po_number) {
            this.formRef.current.setFieldValue('opportunity_po_number', response[0].po_number);
            formData.opportunity_po_number = response.po_number;
        } else if (response[0].po_number === '') {
            this.formRef.current.setFieldValue('opportunity_po_number', '');
            formData.opportunity_po_number = '';
        }

        if (response[0].payment_terms) {
            this.formRef.current.setFieldValue('opportunity_payment_terms', response[0].payment_terms);
            formData.opportunity_payment_terms = response[0].payment_terms;
        }

        this.setState({"bookkeepers": []});
        this.setState({"openMultipleEan": false});
    }

    fetchBookkeeperByCvr = (cvrNumber) => {
        const {receiverType} = this.state;

        if (receiverType === "bookkeeper" || receiverType === "both") {
            const api = `/bookkeeper/${cvrNumber}`;

            fetchGet(api).then((response) => {
                if (response) {
                    let formData = {...this.state.opportunityPatchData};

                    if (response.length === 1) {
                        this.setBookKeeperEmailOrEan(formData, response);
                    } else if (response.length >= 1) {
                        response = response.filter(function (item) {
                            return item.ean !== '';
                        });

                        if (response?.length > 1) {
                            this.setState({"bookkeepers": response});
                            this.setState({"openMultipleEan": true});

                            this.formRef.current.setFieldValue('opportunity_bookkeeper_email', '');
                            this.formRef.current.setFieldValue('opportunity_po_number', '');
                            this.formRef.current.setFieldValue('opportunity_ean', '');

                            formData.opportunity_bookkeeper_email = '';
                            formData.opportunity_po_number = '';
                            formData.opportunity_ean = '';
                        } else {
                            this.setBookKeeperEmailOrEan(formData, response);
                        }
                    } else {
                        formData.opportunity_bookkeeper_email = '';
                        formData.opportunity_po_number = '';
                        formData.opportunity_ean = '';

                        this.formRef.current.setFieldValue('opportunity_bookkeeper_email', '');
                        this.formRef.current.setFieldValue('opportunity_po_number', '');
                        this.formRef.current.setFieldValue('opportunity_ean', '');

                        this.setState({"openMultipleEan": false});
                        this.setState({"bookkeepers": []});
                    }

                    this.setState({"opportunityPatchData": formData});
                }
            })
        }
    }

    checkIfFieldValueHasChanged = () => {
        const {opportunity, setIsOpportunityDirty} = this.props;
        const formValues = this.formRef.current.values;

        if (opportunity.main.opportunity_cvr !== formValues.opportunity_cvr
            || this.state.companyName !== formValues.company_name
            || opportunity.main.opportunity_address_1 !== formValues.opportunity_address_1
            || opportunity.main.opportunity_address_2 !== formValues.opportunity_address_2
            || opportunity.main.opportunity_address_postal_code !== formValues.opportunity_address_postal_code
            || opportunity.main.opportunity_address_city !== formValues.opportunity_address_city
            || opportunity.main.opportunity_address_country !== formValues.opportunity_address_country
            || opportunity.main.opportunity_bookkeeper_email !== formValues.opportunity_bookkeeper_email
            || opportunity.main.opportunity_ean !== formValues.opportunity_ean
            || opportunity.main.opportunity_receiver_email !== formValues.opportunity_receiver_email
            || opportunity.main.opportunity_po_number !== formValues.opportunity_po_number
            || opportunity.main.opportunity_delayed_invoice !== formValues.opportunity_delayed_invoice
            || opportunity.main.opportunity_price !== formValues.opportunity_price
            || opportunity.main.opportunity_split_payment !== formValues.opportunity_split_payment
            || this.state.foodConsideration !== formValues.person_food_considerations_1
            || this.checkFoodAllergiesDirty()
            || opportunity.main.opportunity_food_considerations_other !== formValues.person_food_considerations_other
            || opportunity.main.opportunity_special_conditions !== formValues.opportunity_special_conditions
            || opportunity.main.opportunity_payment_terms !== formValues.opportunity_payment_terms
        ) {
            setIsOpportunityDirty(true);
        } else {
            setIsOpportunityDirty(false);
        }
    }

    checkFoodAllergiesDirty = () => {
        const formValues = this.formRef.current.values;

        if (this.state.foodAllergies.length !== formValues.person_food_considerations_2.length) return true;
        return this.state.foodAllergies.sort().toString() !== formValues.person_food_considerations_2.sort().toString();
    }

    isOpportunityStatusOpen = () => {
        const {opportunity} = this.props;
        const {self_opportunity} = opportunity?.main;
        return self_opportunity && opportunity?.main?.opportunity_status === "open";
    }

    loadPaymentTerms = () => {
        getPaymentTerms()
            .then((res) => {
                if (res.data && this._isMounted) {
                    this.setState({'paymentTermsOptions': res.data});
                }
            })
            .catch((error) => {
                if (this._isMounted) {
                    toast.error(error);
                }
            });
    }

    render() {
        const {
            classes,
            opportunity,
            foodConsiderations,
            postClosedWon_loading,
            oppSaveInfoLoader,
            financeEnabled,
            patchOpportunityDataLoading,
            isOpportunityDirty
        } = this.props;
        const {users, delayInvoiceOptions, productCountry, receiverTypeOptions, receiverType, jobEmail} = this.state;

        return (
            <React.Fragment>
                <Backdrop sx={{color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1}}
                          open={patchOpportunityDataLoading || false}>
                    <CircularProgress color="inherit"/>
                </Backdrop>
                <div className="deals-container">
                    {
                        opportunity?.main.person_food_considerations_set_by_notice !== '' &&
                            <AlertElement severity="info"
                                          message={opportunity?.main.person_food_considerations_set_by_notice}/>

                    }
                    <Grid container sx={{paddingRight: "0px", marginRight: "0px"}}>
                        <Grid item xs={11}>
                            <Typography component="h1" variant="h6" align="left" color="textPrimary"
                                        gutterBottom>
                                {opportunity ? "Company info for invoice" : ""}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Card style={{padding: '12px'}}>
                        {
                            opportunity ? (
                                <Formik
                                    innerRef={this.formRef}
                                    initialValues={{
                                        opportunity_cvr: "",
                                        company_name: "",
                                        opportunity_address_1: "",
                                        opportunity_address_2: "",
                                        opportunity_address_postal_code: "",
                                        opportunity_address_city: "",
                                        opportunity_address_country: "",
                                        opportunity_bookkeeper_email: "",
                                        opportunity_ean: "",
                                        opportunity_receiver_email: "",
                                        opportunity_po_number: "",
                                        opportunity_payment_terms: "",
                                        opportunity_delayed_invoice: "",
                                        opportunity_price: "",
                                        opportunity_split_payment: 0,
                                        opportunity_food_considerations: "",
                                        person_food_considerations_1: "",
                                        person_food_considerations_2: [],
                                        person_food_considerations_other: "",
                                        opportunity_special_conditions: "",
                                    }}
                                    validate={values => {
                                        const errors = {};
                                        const opportunityBookkeeperEmail = values.opportunity_bookkeeper_email?.trim();
                                        const opportunityReceiverEmail = values.opportunity_receiver_email?.trim();

                                        if (this.state.receiverType === "bookkeeper" || this.state.receiverType === "both") {
                                            if (!values.opportunity_ean && !values.opportunity_bookkeeper_email) {
                                                errors.opportunity_ean = 'Required';
                                                errors.opportunity_bookkeeper_email = 'Required';
                                            }

                                            if (opportunityBookkeeperEmail) {
                                                if (!validateEmail(opportunityBookkeeperEmail)) {
                                                    errors.opportunity_bookkeeper_email = 'Invalid email address';
                                                } else {
                                                    if (opportunityBookkeeperEmail === opportunityReceiverEmail) {
                                                        errors.opportunity_bookkeeper_email = 'The email for Receiver and Bookkeeper cannot be the same';
                                                    } else if (opportunityBookkeeperEmail === this.state.jobEmail) {
                                                        errors.opportunity_bookkeeper_email = "The email for Bookkeeper cannot be the person's job email";
                                                    }
                                                }
                                            }

                                            if (values.opportunity_ean) {
                                                if (values.opportunity_ean.length !== 13) {
                                                    errors.opportunity_ean = 'EAN should be 13 characters';
                                                } else {
                                                    const eanValid = validateEan(values.opportunity_ean, false, productCountry?.country_name);

                                                    if (eanValid.valid === false) {
                                                        errors.opportunity_ean = eanValid.error;
                                                    }
                                                }
                                            }
                                        }

                                        if (this.state.receiverType === "receiver" || this.state.receiverType === "both") {
                                            if (!values.opportunity_receiver_email) {
                                                errors.opportunity_receiver_email = 'Required';
                                            } else {
                                                if (opportunityReceiverEmail && !validateEmail(opportunityReceiverEmail)) {
                                                    errors.opportunity_receiver_email = 'Invalid email address';
                                                }
                                            }
                                        }

                                        if (!this.state.receiverType) {
                                            errors.receiver_type = 'Required';
                                        }

                                        if (!values.opportunity_cvr) {
                                            errors.opportunity_cvr = 'Required';
                                        }

                                        if (!values.company_name) {
                                            errors.company_name = 'Required';
                                        }

                                        return errors;
                                    }}
                                    onSubmit={(values, {setSubmitting}) => {

                                        if (this.state.isSaveButtonClicked) {
                                            this.saveInformation();
                                            this.setState({isSaveButtonClicked: false}, () => setSubmitting(false));
                                            return;
                                        }

                                        this.setState({errorMsg: []});

                                        const {opportunity} = this.props;
                                        const selectedEvents = this.props.eventsToOpportunities || {};
                                        const productTypes = opportunity.related_objects.product_types;
                                        const count = Object.keys(selectedEvents).length;
                                        const totalRequiredEvents = (productTypes && productTypes[Object.keys(productTypes)[0]].product_type_events_required) || 1;
                                        //handle primary job condition
                                        const personID = opportunity.related_objects.jobs[opportunity.main.job_id].person_id;
                                        const personObj = opportunity.related_objects.persons[personID];
                                        let errors = [];

                                        setSubmitting(false);

                                        if (count >= totalRequiredEvents && personObj.email && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(personObj.email)) {
                                            let data = {...values};

                                            if (this.state.receiverType === "receiver") {
                                                data = {...values, opportunity_bookkeeper_email: null, opportunity_ean: null};
                                            } else if (this.state.receiverType === "bookkeeper") {
                                                data =  {...values, opportunity_receiver_email: null};
                                            }

                                            this.setState({formValues: data}, () => {
                                                this.handleModal('openWon');
                                            })

                                        } else {
                                            if (count < totalRequiredEvents) {
                                                let msg = `Error: You must select at least ${totalRequiredEvents} event(s) to close this opportunity.`;
                                                errors.push(msg);
                                                this.setState({errorMsg: errors})
                                            }
                                            if (!personObj.email || !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(personObj.email)) {
                                                let msg = `Error: The primary job of the person must have a valid email address.`;
                                                errors.push(msg);
                                                this.setState({errorMsg: errors})
                                            }
                                        }
                                    }}>

                                    {({
                                          submitForm,
                                          isSubmitting,
                                          values,
                                          setFieldValue,
                                          setFieldTouched,
                                          errors,
                                          submitCount
                                      }) => (
                                        <Form>
                                            <Grid container sx={{marginBottom: '15px'}} spacing={1}>
                                                <Grid item xs={12}>
                                                    <Field
                                                        required
                                                        sx={{
                                                            display: 'flex',
                                                            width: '100%',
                                                            maxWidth: '400px',
                                                            margin: 'auto'
                                                        }}
                                                        classes={{input: classes.noPadding}}
                                                        name="opportunity_cvr"
                                                        type="text"
                                                        label="CVR"
                                                        variant="outlined"
                                                        margin="normal"
                                                        component={TextField}
                                                        onBlur={this.handleCVR}
                                                        size="small"
                                                        disabled={!this.isOpportunityStatusOpen}
                                                    />
                                                    <div className='info-message'>
                                                        <p>
                                                            SE Only - CVR Number format is xxxxxxx-xxxx
                                                        </p>
                                                        <p>
                                                            Please enter -1 if client will pay himself instead of
                                                            company's
                                                            account
                                                        </p>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Field
                                                        required
                                                        name="company_name"
                                                        type="text"
                                                        label="Company Name"
                                                        variant="outlined"
                                                        margin="normal"
                                                        fullWidth
                                                        component={TextField}
                                                        onBlur={(e) => this.handleBlur(e)}
                                                        size="small"
                                                        disabled={!this.isOpportunityStatusOpen}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <Tooltip
                                                                        title={opportunity?.main?.opportunity_cvr_company ? "Company name is from opportunity CVR" : "Company name is from person's job"}>
                                                                        <IconButton>
                                                                            <Info/>
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Field
                                                        name="opportunity_address_1"
                                                        type="text"
                                                        label="Address 1"
                                                        variant="outlined"
                                                        margin="normal"
                                                        fullWidth
                                                        component={TextField}
                                                        onBlur={(e) => this.handleBlur(e)}
                                                        size="small"
                                                        disabled={!this.isOpportunityStatusOpen}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Field
                                                        name="opportunity_address_2"
                                                        type="text"
                                                        label="Address 2"
                                                        variant="outlined"
                                                        margin="normal"
                                                        fullWidth
                                                        component={TextField}
                                                        onBlur={(e) => this.handleBlur(e)}
                                                        size="small"
                                                        disabled={!this.isOpportunityStatusOpen}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Field
                                                        name="opportunity_address_postal_code"
                                                        type="text"
                                                        label="Zip Code"
                                                        variant="outlined"
                                                        margin="normal"
                                                        fullWidth
                                                        component={TextField}
                                                        onBlur={(e) => this.handleBlur(e)}
                                                        size="small"
                                                        disabled={!this.isOpportunityStatusOpen}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Field
                                                        name="opportunity_address_city"
                                                        type="text"
                                                        label="City"
                                                        variant="outlined"
                                                        margin="normal"
                                                        fullWidth
                                                        component={TextField}
                                                        onBlur={(e) => this.handleBlur(e)}
                                                        size="small"
                                                        disabled={!this.isOpportunityStatusOpen}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Field
                                                        name="opportunity_address_country"
                                                        type="text"
                                                        label="Country"
                                                        variant="outlined"
                                                        margin="normal"
                                                        fullWidth
                                                        component={TextField}
                                                        onBlur={(e) => this.handleBlur(e)}
                                                        size="small"
                                                        disabled={!this.isOpportunityStatusOpen}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid sx={{marginBottom: '15px'}} container spacing={1}>
                                                <Grid item xs={12}>
                                                    <Typography component="h1" variant="h6" align="left"
                                                                color="textPrimary" gutterBottom>
                                                        Bookkeeping info
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Autocomplete
                                                        disablePortal
                                                        size='small'
                                                        autoComplete={false} // Add this prop to Autocomplete
                                                        options={receiverTypeOptions}
                                                        value={receiverTypeOptions.find(
                                                            (option) => option.key === this.state.receiverType
                                                        ) || null
                                                        }
                                                        isOptionEqualToValue={(option, value) => {
                                                            if (value === "" || value === null) return false;
                                                            return option.key === value.key;
                                                        }}
                                                        onChange={(_e, value) => {
                                                            if (value) {
                                                                const {key} = value;
                                                                this.setState({receiverType: key}, () => {
                                                                    if (values.opportunity_cvr && !(values.opportunity_bookkeeper_email || values.opportunity_ean)) {
                                                                        this.fetchBookkeeperByCvr(values.opportunity_cvr);
                                                                    }

                                                                    if (key === "bookkeeper") {
                                                                        setFieldValue('opportunity_receiver_email', '');
                                                                    } else {
                                                                        if (opportunity.main.opportunity_receiver_email) {
                                                                            setFieldValue('opportunity_receiver_email', opportunity.main.opportunity_receiver_email);
                                                                        } else {
                                                                            setFieldValue('opportunity_receiver_email', jobEmail);
                                                                        }

                                                                        if (key === "receiver") {
                                                                            setFieldValue('opportunity_ean', '');
                                                                            setFieldValue('opportunity_bookkeeper_email', '');
                                                                        }
                                                                    }
                                                                });
                                                            } else {
                                                                this.setState({receiverType: ""});
                                                            }
                                                        }}
                                                        onBlur={(e) => this.handleBlur(e)}
                                                        renderInput={(params) =>
                                                            <MaterialTextField {...params}
                                                                    label="Receiver Type *"
                                                                    inputProps={{
                                                                        ...params.inputProps,
                                                                        readOnly: true, // to turn off autocomplete suggestions by browser
                                                                    }}
                                                                    error={(submitCount > 0 && errors.receiver_type?.length > 0)}/>
                                                        }
                                                        disabled={!this.isOpportunityStatusOpen}
                                                    />
                                                    { submitCount > 0 && errors.receiver_type && <div
                                                        style={{
                                                            color: "red",
                                                            fontSize: "0.75rem",
                                                            margin: "4px 14px 0px",
                                                        }}
                                                    >
                                                        {errors.receiver_type}
                                                    </div>
                                                    }
                                                </Grid>
                                                {
                                                    (receiverType === 'receiver' || receiverType === 'both') &&
                                                    <Grid item xs={6}>
                                                        <Field
                                                            name="opportunity_receiver_email"
                                                            type="text"
                                                            label="Receiver e-mail"
                                                            variant="outlined"
                                                            margin="normal"
                                                            fullWidth
                                                            required
                                                            component={TextField}
                                                            onBlur={(e) => this.handleBlur(e)}
                                                            size="small"
                                                            disabled={!this.isOpportunityStatusOpen}
                                                        />
                                                    </Grid>
                                                }
                                                {
                                                    (receiverType === 'bookkeeper' || receiverType === 'both') &&
                                                        <Grid item xs={6}>
                                                            <Field
                                                                name="opportunity_bookkeeper_email"
                                                                type="text"
                                                                label="Bookkeeper e-mail"
                                                                variant="outlined"
                                                                margin="normal"
                                                                fullWidth
                                                                required
                                                                component={TextField}
                                                                onBlur={(e) => this.handleBlur(e)}
                                                                size="small"
                                                                disabled={!this.isOpportunityStatusOpen}
                                                            />
                                                        </Grid>
                                                }
                                                {
                                                    (receiverType === 'bookkeeper' || receiverType === 'both') &&
                                                        <Grid item xs={6}>
                                                            <Field
                                                                name="opportunity_ean"
                                                                type="text"
                                                                label="EAN"
                                                                variant="outlined"
                                                                margin="normal"
                                                                fullWidth
                                                                required
                                                                component={TextField}
                                                                onBlur={(e) => {
                                                                    let opportunityEan = values.opportunity_ean?.trim();
                                                                    opportunityEan = opportunityEan?.replace(/^0+/, "");

                                                                    setFieldValue('opportunity_ean', opportunityEan)
                                                                    this.handleBlur(e)
                                                                }}
                                                                size="small"
                                                                disabled={!this.isOpportunityStatusOpen}
                                                                InputProps={{
                                                                    endAdornment: this.state.bookkeepers?.length > 0 && (
                                                                        <InputAdornment position="end">
                                                                            <Tooltip
                                                                                title="Multiple EAN List">
                                                                                <IconButton onClick={() => {
                                                                                    this.setState({"openMultipleEan": true})
                                                                                }}>
                                                                                    <Info/>
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        </InputAdornment>
                                                                    )
                                                                }}
                                                            />
                                                        </Grid>
                                                }
                                                <Grid item xs={6}>
                                                    <Field
                                                        name="opportunity_po_number"
                                                        type="text"
                                                        label="PO Number"
                                                        variant="outlined"
                                                        margin="normal"
                                                        fullWidth
                                                        component={TextField}
                                                        onBlur={(e) => this.handleBlur(e)}
                                                        size="small"
                                                        disabled={!this.isOpportunityStatusOpen}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid sx={{marginBottom: '15px'}} container spacing={1}>
                                                <Grid item xs={12}>
                                                    <Typography component="h1" variant="h6" align="left"
                                                                color="textPrimary">
                                                        Payment Terms
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <Autocomplete
                                                        disablePortal
                                                        size='small'
                                                        id="combo-box"
                                                        options={delayInvoiceOptions}
                                                        sx={{width: '100%'}}
                                                        onChange={(_e, value) => {
                                                            if (value) {
                                                                setFieldValue("opportunity_delayed_invoice", value?.key)
                                                            } else {
                                                                setFieldValue("opportunity_delayed_invoice", "")
                                                            }
                                                        }}
                                                        onBlur={() => {
                                                            this.checkIfFieldValueHasChanged();
                                                        }}
                                                        value={values.opportunity_delayed_invoice}
                                                        isOptionEqualToValue={(option, value) => {
                                                            if (value === "" || value === null) return false;
                                                            return option.key === value || option.id === value;
                                                        }}
                                                        renderInput={(params) => <MaterialTextField {...params}
                                                                                                    label="Delay Invoice"/>}
                                                        disabled={!this.isOpportunityStatusOpen}
                                                    />
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <Field
                                                        name="opportunity_price"
                                                        type="text"
                                                        label="Price"
                                                        variant="outlined"
                                                        margin="normal"
                                                        fullWidth
                                                        component={TextField}
                                                        onBlur={(e) => this.handleBlur(e)}
                                                        size="small"
                                                        disabled={!this.isOpportunityStatusOpen}
                                                    />
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <Autocomplete
                                                        name={`opportunity_payment_terms`}
                                                        disablePortal
                                                        margin='normal'
                                                        size='small'
                                                        id='combo-box'
                                                        options={this.state.paymentTermsOptions}
                                                        value={this.state.paymentTermsOptions.find(
                                                            (option) => option.name === values.opportunity_payment_terms
                                                        ) || null
                                                        }
                                                        isOptionEqualToValue={(option, value) => {
                                                            if (value === "" || value === null) return false;
                                                            return option.name === value;
                                                        }}
                                                        getOptionLabel={(option) => option.name}
                                                        onChange={(_event, newValue) => {
                                                            const selected = newValue ? newValue.name : "";
                                                            setFieldValue(
                                                                `opportunity_payment_terms`,
                                                                selected
                                                            );
                                                        }}
                                                        onBlur={() => {
                                                            setFieldTouched(
                                                                `opportunity_payment_terms`,
                                                                true
                                                            );
                                                        }}
                                                        renderInput={(params) => (
                                                            <MaterialTextField
                                                                {...params}
                                                                label='Payment Terms'
                                                            />
                                                        )}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid sx={{marginBottom: '15px'}} container spacing={1}>
                                                <Grid item xs={5} sx={{display: 'flex', alignItems: 'center'}}>
                                                    <label>
                                                        <input type="checkbox" name="opportunity_split_payment"
                                                               checked={Boolean(values.opportunity_split_payment)}
                                                               disabled={!this.isOpportunityStatusOpen}
                                                               onChange={(e) => {
                                                                   const val = e.target.checked ? 1 : 0;
                                                                   this.formRef.current.setFieldValue('opportunity_split_payment', val);
                                                                   setTimeout(() => this.checkIfFieldValueHasChanged(), 0);
                                                               }}
                                                        />
                                                        50% now, 50% after 2nd meeting
                                                    </label>
                                                </Grid>
                                            </Grid>

                                            <Grid sx={{marginBottom: '15px'}} container spacing={1}>
                                                <Grid item xs={11}>
                                                    <Typography component="h1" variant="h6" align="left"
                                                                color="textPrimary">
                                                        Extra Information
                                                    </Typography>

                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Typography component="h6" variant="h6" align="left"
                                                                color="textPrimary"
                                                                sx={{fontSize: '16px', margin: '10px 0 5px'}}>
                                                        Food Consideration
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    {
                                                        this.isOpportunityStatusOpen() ? (
                                                            <>
                                                                <div className="food-consideration-section">
                                                                    <SelectBox
                                                                        multiple={false}
                                                                        name="person_food_considerations_1"
                                                                        type="type1_food"
                                                                        label="Select Type"
                                                                        labelId="select-type"
                                                                        options={foodConsiderations ? foodConsiderations : []}
                                                                        onBlur={(e) => this.handleBlur(e)}
                                                                    />
                                                                    <SelectBox
                                                                        multiple={true}
                                                                        name="person_food_considerations_2"
                                                                        type="type2_food"
                                                                        label="Select Allergy"
                                                                        labelId="select-allergy"
                                                                        onChange={this.handleAllergiesChange}
                                                                        options={foodConsiderations ? foodConsiderations : []}
                                                                    />
                                                                </div>
                                                                {
                                                                    this.formRef?.current?.values?.person_food_considerations_2?.filter((item) => item === 16).length > 0 && (
                                                                        <Field
                                                                            component="textarea"
                                                                            fullWidth
                                                                            rows="5"
                                                                            size="large"
                                                                            name="person_food_considerations_other"
                                                                            style={{
                                                                                width: '100%',
                                                                                padding: '10px',
                                                                                fontSize: '16px',
                                                                                borderColor: "#c4c4c4",
                                                                                borderRadius: '5px'
                                                                            }}
                                                                            placeholder="Please write other allergies"
                                                                            onBlur={(e) => this.handleBlur(e)}
                                                                        />
                                                                    )
                                                                }
                                                            </>
                                                        ) : (
                                                            <Field
                                                                type="text"
                                                                label="Food Consideration"
                                                                name="opportunity_food_considerations"
                                                                multiline
                                                                rows="5"
                                                                variant="outlined"
                                                                margin="normal"
                                                                fullWidth
                                                                component={TextField}
                                                                disabled={true}
                                                            />
                                                        )
                                                    }

                                                    <Field
                                                        type="text"
                                                        label="Special conditions"
                                                        name="opportunity_special_conditions"
                                                        multiline
                                                        rows="4"
                                                        variant="outlined"
                                                        margin="normal"
                                                        fullWidth
                                                        component={TextField}
                                                        onBlur={(e) => this.handleBlur(e)}
                                                        disabled={!this.isOpportunityStatusOpen}
                                                    />
                                                </Grid>
                                            </Grid>

                                            {
                                                this.isOpportunityStatusOpen() && (
                                                    <>
                                                        <Grid container sx={{marginBottom: '15px'}} spacing={1}>
                                                            <Grid item xs={12}>
                                                                <div>
                                                                    {
                                                                        this.state.errorMsg.map((msg, index) => {
                                                                            return (
                                                                                <p key={index} style={{
                                                                                    textAlign: 'center',
                                                                                    color: 'red',
                                                                                    margin: 0
                                                                                }}>{msg}</p>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid container sx={{marginBottom: '15px'}} spacing={1}>
                                                            <Grid item xs={12} sx={{
                                                                display: 'flex',
                                                                justifyContent: 'space-between'
                                                            }}>
                                                                <Button
                                                                    variant="contained"
                                                                    color="error"
                                                                    disabled={isSubmitting}
                                                                    onClick={() => this.handleModal('openLost')}
                                                                >
                                                                    Close as lost
                                                                </Button>
                                                                <LoadingButton
                                                                    variant="contained"
                                                                    color="success"
                                                                    disabled={isSubmitting}
                                                                    onClick={submitForm}
                                                                    loading={postClosedWon_loading}
                                                                >
                                                                    Close as won
                                                                </LoadingButton>
                                                                <LoadingButton
                                                                    variant="contained"
                                                                    color="primary"
                                                                    disabled={isSubmitting || !isOpportunityDirty}
                                                                    onClick={() => {
                                                                        // validate
                                                                        this.setState({isSaveButtonClicked: true}, () => {
                                                                            submitForm();
                                                                        });
                                                                    }}
                                                                    loading={oppSaveInfoLoader}
                                                                >
                                                                    Save
                                                                </LoadingButton>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid container sx={{marginBottom: '15px'}} spacing={1}>
                                                            <Grid item xs={12}>
                                                                <Typography component="h1" variant="h6" align="center"
                                                                            color="textPrimary">
                                                                    Transfer opportunity to another user
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12}
                                                                  sx={{display: 'flex', justifyContent: 'center'}}>
                                                                <Autocomplete
                                                                    disablePortal
                                                                    id="combo-box-demo"
                                                                    options={users}
                                                                    sx={{width: 300}}
                                                                    onChange={this.handleTransferOpportunity}
                                                                    renderInput={(params) =>
                                                                        <MaterialTextField {...params}
                                                                                           label="Select a user"/>}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </>
                                                )
                                            }

                                            <LostModalV2
                                                open={this.state.openLost && opportunity?.main.opportunity_type === RESALE}
                                                onClose={this.handleClose}
                                                opportunity={opportunity}
                                                formDataValues={this.formRef.current === null ? null : this.formRef.current.values}
                                            />

                                            <NewSaleLostModal
                                                open={this.state.openLost && (opportunity?.main.opportunity_type === NEW_SALE || opportunity?.main.opportunity_type === WIN_BACK_TYPE)}
                                                onClose={this.handleClose}
                                                opportunity={opportunity}
                                                formDataValues={this.formRef.current === null ? null : this.formRef.current.values}
                                            />

                                            <WonModal
                                                open={this.state.openWon}
                                                onClose={this.handleClose}
                                                opportunity={opportunity}
                                                formData={this.state.formValues}
                                            />

                                            <CvrModal
                                                open={this.state.openCvr}
                                                onClose={() => this.handleClose("cvr")}
                                                opportunity={opportunity}
                                                formData={this.formRef.current === null ? null : this.formRef.current.values}
                                                cvrData={this.state.cvrData}
                                                formReference={this.formRef}
                                            />

                                            <TransferModal
                                                open={this.state.openTransfer}
                                                onClose={this.handleClose}
                                                pipelineID={this.state.pipelineID}
                                                emptySalesRep={() => this.setState({salesRep: ""})}
                                                formDataValues={this.formRef.current === null ? null : this.formRef.current.values}
                                            />

                                            {financeEnabled && productCountry?.country_name === DENMARK &&
                                                <SwitchToInvoicesConfirmationModal
                                                    open={this.state.openSwitchToInvoicesConfirmation}
                                                    onClose={this.handleClose}
                                                />
                                            }

                                            <MultipleEanModal
                                                open={this.state.openMultipleEan}
                                                onClose={(item) => {
                                                    this.setState({"openMultipleEan": false})
                                                    if (item) {
                                                        setFieldValue('opportunity_ean', item.ean);
                                                        setFieldValue('opportunity_payment_terms', item.payment_terms);
                                                    }
                                                }}
                                                data={this.state.bookkeepers}
                                            />
                                        </Form>
                                    )}
                                </Formik>
                            ) : (
                                <></>
                            )
                        }
                    </Card>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    errorMessage: opportunitySelectors.errorMessage(state),
    opportunity: opportunitySelectors.opportunity(state),
    partialOpportunityData: opportunitySelectors.partialOpportunityData(state),
    salesReps: opportunitySelectors.salesReps(state),
    cvr: opportunitySelectors.cvr(state),
    pipelineId: opportunitySelectors.pipelineId(state),
    stages: opportunitySelectors.stages(state),
    pipelines: dashboardSelectors.pipelines(state),
    user: accountSelectors.user(state),
    foodConsiderations: contactsSelectors.foodConsiderations(state),
    postClosedWon_loading: opportunitySelectors.postClosedWonLoading(state),
    closedWon: opportunitySelectors.closedWon(state),
    opportunity_loading: opportunitySelectors.opportunity_loading(state),
    oppSaveInfoLoader: opportunitySelectors.oppSaveInfoLoader(state),
    financeEnabled: adminSelectors.financeEnabled(state),
    patchOpportunityDataLoading: opportunitySelectors.patchOpportunityDataLoading(state),
    isOpportunityDirty: opportunitySelectors.isOpportunityDirty(state),
    eventsToOpportunities: opportunitySelectors.eventsToOpportunities(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        patchOpportunityData: opportunityActions.patchOpportunityData,
        postOpportunityData: opportunityActions.postOpportunityData,
        searchCvr: opportunityActions.searchCvr,
        getSalesReps: opportunityActions.getSalesReps,
        getPipelineId: opportunityActions.getPipelineId,
        getStages: opportunityActions.getStages,
        getFoodConsiderations: contactsActions.getFoodConsiderations,
        setIsOpportunityDirty: opportunityActions.setIsOpportunityDirty,
    },
    dispatch);

function WithNavigate(props) {
    let params = useParams();
    return <Deal {...props} params={params}/>
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(useStyles)(WithNavigate));
